import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WifiDisabledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 19.6L9.22 16.46L5.96 20.06L4.62 18.86L8.02 15.1L2 8.3C4.82 5.84 8.42 4.54 12 4.54C13.64 4.54 15.28 4.82 16.84 5.34L19.72 2.16L21.08 3.36L18.62 6.08C19.82 6.66 20.96 7.4 22 8.3L12 19.6ZM12 6.4C9.7 6.4 7.36 7 4.68 8.58L9.26 13.72L15.46 6.88C14.26 6.54 13.14 6.4 12 6.4ZM10.46 15.08L12 16.8L19.32 8.58C18.62 8.18 17.94 7.82 17.3 7.54L10.46 15.08Z" />
    </SvgIcon>
  );
});
